import styled from 'styled-components';
import { EnrollmentCardContainerComp } from './EnrollmentCardContainerComp';

export const StyledEnrollmentCardContainerComp = styled(EnrollmentCardContainerComp)`
  width: 100%;
`;
